// extracted by mini-css-extract-plugin
export var base = "_15-0";
export var updateBanner = "_15-1";